/**
 * One of the Privacy / Terms / Support pages (B-034-PRIV), rendered with the Kośa's
 * block renderer inside the site's card.
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import KosaArticle from '../Learnings/KosaArticle';
import { CONTACT_EMAIL, LEGAL_ORDER, LEGAL_PAGES, LegalId } from './legal';

const LABEL: Record<LegalId, string> = { privacy: 'Privacy', terms: 'Terms', support: 'Support' };

const formatDate = (iso: string) =>
  new Date(`${iso}T12:00:00Z`).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });

const LegalPage: React.FC<{ id: LegalId }> = ({ id }) => {
  const page = LEGAL_PAGES[id];
  return (
    <div className="max-w-3xl mx-auto space-y-4">
      <nav aria-label="Policies" className="flex gap-4 text-sm">
        {LEGAL_ORDER.map((p) => (
          <a
            key={p}
            href={`/${p}`}
            aria-current={p === id ? 'page' : undefined}
            className={p === id ? 'font-semibold text-foreground' : 'text-brand dark:text-brand-dark hover:underline'}
          >
            {LABEL[p]}
          </a>
        ))}
      </nav>
      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-xl font-semibold text-brand dark:text-brand-dark">{page.title}</CardTitle>
          <p className="text-sm text-muted-foreground mt-1">{page.subtitle}</p>
          <p className="text-xs text-muted-foreground mt-2">Last updated {formatDate(page.updated)}</p>
        </CardHeader>
        <CardContent className="space-y-6">
          <p className="text-[14px]">
            Contact:{' '}
            <a href={`mailto:${CONTACT_EMAIL}`} className="text-brand dark:text-brand-dark hover:underline break-all">
              {CONTACT_EMAIL}
            </a>
          </p>
          <KosaArticle article={{ id: page.id, sections: page.sections }} />
        </CardContent>
      </Card>
    </div>
  );
};

export default LegalPage;
